import React from 'react';
import Icons from './Icons';

function Footer() {
  return (
    <>
      <footer className="bg-white dark:bg-gray-900 py-2 md:py-12 border-t border-green-500 font-[PingFang SC,Helvetica Neue,sans-serif]">
        <div className="container mx-auto text-center text-sm md:text-base text-gray-500 dark:text-gray-300">
          <h3 className="text-2xl font-semibold text-green-600 dark:text-green-400 mb-4 hidden md:block tracking-tight">WeKuplusam</h3>
          <p className="hidden mb-4 md:block text-gray-600 dark:text-gray-400">
            Наша главная задача - сделать процесс покупки автомобиля из других стран прозрачнее и дешевле.
          </p>
          <p className="md:mb-2">
            Следите за новостями в нашем TG
            <a href="https://t.me/Kuplusam" className="text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-300 ml-2 transition-colors duration-200">
              <Icons name="TgBlue" classNameIcons="inline-block ml-1 dark:hidden " />
              <Icons name="TgDark" classNameIcons="hidden ml-1 dark:inline-block " />
            </a>
          </p>
          <div className="border-t border-green-200 dark:border-green-800 mt-8 pt-8 text-center text-gray-400 hidden md:block">
            <p>© 2025 WeKuplusam. Все права защищены.</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
